import { render, staticRenderFns } from "./PCFooter.vue?vue&type=template&id=1ca4de32&scoped=true"
import script from "./PCFooter.vue.js?vue&type=script&lang=js&external"
export * from "./PCFooter.vue.js?vue&type=script&lang=js&external"
import style0 from "./PCFooter.vue?vue&type=style&index=0&id=1ca4de32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4de32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
